import actionTypes from 'constants/actionTypes'

interface SocketState {
  connectionState: 'connected' | 'connecting' | 'disconnected'
}

interface SocketAction {
  type: string
}

const initialState: SocketState = {
  connectionState: 'disconnected',
}

export default (state: SocketState = initialState, action: SocketAction): SocketState => {
  switch (action.type) {
    case actionTypes.CONNECTION.SOCKET.CONNECTED:
      return { connectionState: 'connected' }
    case actionTypes.CONNECTION.SOCKET.CONNECTING:
      return { connectionState: 'connecting' }
    case actionTypes.CONNECTION.SOCKET.DISCONNECTED:
      return { connectionState: 'disconnected' }
  }
  return state
}
